


































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbShopAccount,  TbSettingsPad,TbShop } from '@/http';
import { NumberKeyboard,logoutPanel } from "@/components";
import { Toast } from 'vant';
import QRCode from 'qrcodejs2'
const { userAgent } = navigator;
const isAndroid = userAgent.indexOf('Android') > -1 ||userAgent.indexOf('android') > -1 || userAgent.indexOf('Adr') > -1;; // android终端
@Component({ 
    components: {
        NumberKeyboard,logoutPanel
    },
})
export default class dpInfo extends Vue {
   
    public $refs: {
    };
    userInfo = {};
    shopInfo = {};
    //标签打印机名称
    labelPrinterName="";
    // 不是珠宝的话1、40*30 2、40*60   
    activeitem=1;

    // 1、40*30 2、40*60 3、25*15 
    pageSize = null;

    padSetInfo:any={
        id:"",
        settingContent:{
            shopName:{
                isSelect:true,
                value:''
            },
            number:{
                isSelect:true,
                value:''
            },
            name:{
                isSelect:true,
                value:''
            },
            goodsNum:{
                isSelect:true,
                value:''
            },
            specifications:{
                isSelect:true,
                value:''
            },
            retailPrice:{
                isSelect:true,
                value:''
            },
            currency:{
                isSelect:true,
                value:''
            },
            supplier:{
                isSelect:true,
                value:''
            },
            goodsClass:{
                isSelect:true,
                value:''
            },
            safetyLevel:{
                isSelect:true,
                value:''
            },
            material:{
                isSelect:true,
                value:''
            },
            qualityLevel:{
                isSelect:true,
                value:''
            },
            standard:{
                isSelect:true,
                value:''
            },
            ironing:{
                isSelect:true,
                value:''
            },
            doNotWash:{
                isSelect:true,
                value:''
            },
            noWring:{
                isSelect:true,
                value:''
            },
            lowTemperature:{
                isSelect:true,
                value:''
            },
            dryClean:{
                isSelect:true,
                value:''
            },
            washingMethod:{
                isSelect:true,
                value:''
            },
            bold:{
                isSelect:true,
                value:''
            },
        },
    };
    padSetInfo3:any={
        id:"",
        settingContent:{
            shopName:{
                isSelect:true,
                value:''
            },
            name:{
                isSelect:true,
                value:''
            },
            specifications:{
                isSelect:true,
                value:''
            },
            retailPrice:{
                isSelect:true,
                value:''
            },
            currency:{
                isSelect:true,
                value:''
            },
            number:{
                isSelect:true,
                value:''
            },
        },
    };
    padSetInfo2:any={
        id:"",
        settingContent:{
            shopName:{
                isSelect:true,
                value:''
            },
            number:{
                isSelect:true,
                value:''
            },
            name:{
                isSelect:true,
                value:''
            },
            goodsNum:{
                isSelect:true,
                value:''
            },
            specifications:{
                isSelect:true,
                value:''
            },
            retailPrice:{
                isSelect:true,
                value:''
            },
            currency:{
                isSelect:true,
                value:''
            },
            supplier:{
                isSelect:true,
                value:''
            },
            goodsClass:{
                isSelect:true,
                value:''
            },
            safetyLevel:{
                isSelect:true,
                value:''
            },
            material:{
                isSelect:true,
                value:''
            },
            qualityLevel:{
                isSelect:true,
                value:''
            },
            bold:{
                isSelect:true,
                value:''
            },
        },
    }
    labelInfo=[
    {
        code:'此处显示货号',
        classStr:'棉100%/江苏/藏蓝色',
        className:'此处显示品名',
        barCode:"123456789123456789",
        goodsClassName:"服装/女装",
        safetyLevel:"A级",
        material:"蚕丝",
        qualityLevel:"A级",
        washingMethod:"此处显示商品所维护的洗涤方式若商品未维护则不显示最多...",
        titleStr:'',
        sellStr:"399.00",
        number:"",
        standard: "",
        supplierName: "四季服装城名称过长...",
        shortBarCode:"123456789123456789"
    }
    ]
    labelInfo1=[
    {
        code:'此处显示货号',
        classStr:'棉100%/江苏',
        className:'此处显示品名',
        barCode:"0002",
        goodsClassName:"服装/女装",
        safetyLevel:"A级",
        material:"蚕丝",
        qualityLevel:"A级",
        washingMethod:"此处显示商品所维护的洗涤方式若商品未维护则不显示最多...",
        titleStr:'',
        sellStr:"399.00",
        number:"",
        standard: "",
        supplierName: "四季服装城名称过长...",
        shortBarCode:"0002"
    }
    ]
    checked=true;
    concatName="";
    concatPhone="";

    isEdit1=false;
    isLoading1= false;

    //二维码
    QRCode = null
    qrcode = null
    QRCode1 = null
    qrcode1 = null

    dateShow=false;
    startTime="";
    endTime="";

    czstartTime="";
    czendTime="";

    isPrintLoading = false;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    //货币下拉框
    showHbPopover = false;
    option1 = [{label:'人民币￥',value:'¥'},{label:'美元$',value:'＄'},{label:'港币HK$',value:'HK＄'},{label:'澳门币MOP$',value:'MOP＄'},{label:'令吉RM',value:'RM'},{label:'阿曼OMR',value:'OMR'},{label:'泰铢THB',value:'THB'},{label:'无货币符号',value:''}];
    firstSize = null;

    get getWashArr(){
        let str="";
        let washArr=[];
        if(this.pageSize==2&&this.padSetInfo&&this.padSetInfo.settingContent){
            if(this.padSetInfo.settingContent.ironing&&this.padSetInfo.settingContent.ironing.isSelect){
                washArr.push('中温熨烫');
            }
            if(this.padSetInfo.settingContent.doNotWash&&this.padSetInfo.settingContent.doNotWash.isSelect){
                washArr.push('不可机洗');
            }
            if(this.padSetInfo.settingContent.noWring&&this.padSetInfo.settingContent.noWring.isSelect){
                washArr.push('不可拧干');
            }
            if(this.padSetInfo.settingContent.lowTemperature&&this.padSetInfo.settingContent.lowTemperature.isSelect){
                washArr.push('低温手洗');
            }
            if(this.padSetInfo.settingContent.dryClean&&this.padSetInfo.settingContent.dryClean.isSelect){
                washArr.push('标准干洗');
            }
            if(washArr.length>0){
                str=washArr.join('/');
            }
        }
        return str;
    }

    created() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
    }

    async mounted(){
        //  /**返回连接蓝牙 */
        //  window['finishBluetooth'] = (val) => {
        //     if(val=='1'){
        //         this.jumpBluetooth(val);
        //     }else if(val=='true'){
        //         if(localStorage.getItem('blueInfo')){
        //             window.webkit.messageHandlers.connectPrinter.postMessage(localStorage.getItem('blueInfo'));
        //             localStorage.removeItem('blueInfo')
        //         }
        //     }
        // }
        this.shopInfo = await TbShop.GetTbShopById({id:this.userInfo['shopId']});
        if(localStorage.getItem('labelPrinterName') && localStorage.getItem('labelPrinterName')!='null'){
            this.labelPrinterName = localStorage.getItem('labelPrinterName');
        }
        if(localStorage.getItem('labelPaperSize')){
            let val =Number(localStorage.getItem('labelPaperSize'));
            console.log('val',val);
            if(this.userInfo['isJewelry']){
                this.pageSize = 3;
                // window.webkit.messageHandlers.setPageSize.postMessage(3);
            }else{
                this.pageSize = val;
                // window.webkit.messageHandlers.setPageSize.postMessage(val);
            }
        }else{
            if(this.userInfo['isJewelry']){
                this.pageSize = 3;
                // window.webkit.messageHandlers.setPageSize.postMessage(3);
            }else{
                this.pageSize = 1;
                // window.webkit.messageHandlers.setPageSize.postMessage(1);
            }
        }
        await this.init();
        // this.searchForBluetooth();
        // this.getConnectBluetooth();
       
        
    }
    activated() {
        if(localStorage.getItem('labelPrinterName')){
            this.labelPrinterName = localStorage.getItem('labelPrinterName');
        }
        
    }
    jumpBluetooth(val){
        if(!isAndroid){
            window.webkit.messageHandlers.searchForBluetooth.postMessage('searchForBluetooth');
        }
        this.$router.push(`/pad/setting/chooseBlue`);
    }
    /**获取货币符号展示 */
    get getChoiceHb2(){
        let str = ""
        str = this.option1.findIndex(v=>v.value==this.padSetInfo2.settingContent.currency.value)>-1?this.option1.find(v=>v.value==this.padSetInfo2.settingContent.currency.value).label:'';
        return str;
    }
    /**获取货币符号展示 */
    get getChoiceHb1(){
        let str = ""
        str = this.option1.findIndex(v=>v.value==this.padSetInfo.settingContent.currency.value)>-1?this.option1.find(v=>v.value==this.padSetInfo.settingContent.currency.value).label:'';
        return str;
    }
    /**获取货币符号展示 */
    get getChoiceHb3(){
        let str = ""
        str = this.option1.findIndex(v=>v.value==this.padSetInfo3.settingContent.currency.value)>-1?this.option1.find(v=>v.value==this.padSetInfo3.settingContent.currency.value).label:'';
        return str;
    }
    searchForBluetooth(){
        // 搜索蓝牙
        window.webkit.messageHandlers.searchForBluetooth.postMessage('searchForBluetooth')
    }
    getConnectBluetooth(){
        // 获取连接蓝牙的方法名
        let form = {
            name:localStorage.getItem('labelPrinterName')?localStorage.getItem('labelPrinterName'):'',
            type:1,
        }
        window.webkit.messageHandlers.getConnectBluetooth.postMessage(JSON.stringify(form));
    }
    openBlue(){
        this.searchForBluetooth();
        this.$router.push(`/pad/setting/chooseBlue?name=dp`);
    }
    async changeItem(val){
        this.firstSize = val;
        if(this.isEdit1) {
            this.tipTitle = "操作提醒";
            this.tipText = `当前模版配置信息尚未保存，需要保存吗？`;
            this.btnNums=2;
            this.confirmText = "保存并切换";
            this.cancelText = "取消"
            this.tipType = 1;
            this.$nextTick(()=>{
                this.tipShow = true;
            })
            return;
        }
        this.pageSize = val;
        console.log('this.pageSize',this.pageSize);
        localStorage.setItem('labelPaperSize',val);
        await this.init();
        window.webkit.messageHandlers.setPageSize.postMessage(val);
    }
    /**提示弹窗 */
    async tipConfirm(){
        switch (this.tipType) {
            case 1:
                this.saveEdit(1);
                break;
            default:
                break;
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }
    async init(){
        if(this.pageSize==1){
          /**40*30 */
          let res =  await TbSettingsPad.GetTbSettings({settingtype:7});
          this.padSetInfo2 =res;
          if(res.settingContent.shopName){
                this.padSetInfo2.settingContent.shopName.value=res.settingContent.shopName.value?res.settingContent.shopName.value:this.shopInfo.shopName;
            }
      }else if(this.pageSize==2){
          /**40*60 */
          let res = await TbSettingsPad.GetTbSettings({settingtype:10});
          this.padSetInfo = res;
          if(res.settingContent.shopName){
                this.padSetInfo.settingContent.shopName.value=res.settingContent.shopName.value?res.settingContent.shopName.value:this.shopInfo.shopName;
            }
        }else {
            /**25*15 */
            let res = await TbSettingsPad.GetTbSettings({settingtype:12});
            this.padSetInfo3 = res;
            if(res.settingContent.shopName){
                    this.padSetInfo3.settingContent.shopName.value=res.settingContent.shopName.value?res.settingContent.shopName.value:this.shopInfo.shopName;
                }
        }
        this.$forceUpdate();
    }
    changeRadio(val,type){
        if(!this.isEdit1) return;
        switch (type) {
            case 1:
                // this.padSetInfo.settingContent.isPut=val;
                break;
            case 2:
                this.padSetInfo2.settingContent.shopName.isSelect=val;
                if(val){
                    this.padSetInfo2.settingContent.shopName.value = this.shopInfo['shopName'];
                }else{
                    this.padSetInfo2.settingContent.shopName.value="";
                }
                break;
            case 3:
                this.padSetInfo2.settingContent.number.isSelect=val;
                break;
            case 4:
                this.padSetInfo2.settingContent.specifications.isSelect=val;
                break;
            case 5:
                this.padSetInfo2.settingContent.retailPrice.isSelect=val;
                break;
            case 6:
                this.padSetInfo2.settingContent.goodsNum.isSelect=val;
                break;
            default:
                break;
                
        }
    }
    changeRadio60(val,type){
        if(!this.isEdit1) return;
        switch (type) {
            case 1:
                // this.padSetInfo.settingContent.isPut=val;
                break;
            case 2:
                this.padSetInfo.settingContent.shopName.isSelect=val;
                if(val){
                    this.padSetInfo.settingContent.shopName.value = this.shopInfo['shopName'];
                }else{
                    this.padSetInfo.settingContent.shopName.value="";
                }
                break;
            case 3:
                this.padSetInfo.settingContent.number.isSelect=val;
                break;
            case 4:
                this.padSetInfo.settingContent.specifications.isSelect=val;
                break;
            case 5:
                this.padSetInfo.settingContent.retailPrice.isSelect=val;
                break;
            case 6:
                this.padSetInfo.settingContent.goodsNum.isSelect=val;
                break;
            case 7:
                this.padSetInfo.settingContent.supplier.isSelect=val;
                break;
            case 8:
                this.padSetInfo.settingContent.goodsClass.isSelect=val;
                break;
            case 9:
                this.padSetInfo.settingContent.safetyLevel.isSelect=val;
                break;
            case 10:
                this.padSetInfo.settingContent.material.isSelect=val;
                break;
            case 11:
                this.padSetInfo.settingContent.qualityLevel.isSelect=val;
                break;
            case 12:
                this.padSetInfo.settingContent.standard.isSelect=val;
                break;
            case 13:
                this.padSetInfo.settingContent.washingMethod.isSelect=val;
                this.resetXd(val);
                break;
            default:
                break;
                
        }
    }
    changeRadio25(val,type){
        if(!this.isEdit1) return;
        switch (type) {
            case 1:
                break;
            case 2:
                this.padSetInfo3.settingContent.shopName.isSelect=val;
                if(val){
                    this.padSetInfo3.settingContent.shopName.value = this.shopInfo['shopName'];
                }else{
                    this.padSetInfo3.settingContent.shopName.value="";
                }
                break;
            case 3:
                break;
            case 4:
                this.padSetInfo3.settingContent.specifications.isSelect=val;
                if(val){
                    this.padSetInfo3.settingContent.number.isSelect = !val;
                }
                break;
            case 5:
                this.padSetInfo3.settingContent.retailPrice.isSelect=val;
                break;
            case 6:
                // this.padSetInfo2.settingContent.goodsNum.isSelect=val;
                break;
            case 7:
                this.padSetInfo3.settingContent.number.isSelect=val;
                if(val){
                    this.padSetInfo3.settingContent.specifications.isSelect = !val;
                }
                break;
            default:
                break;
                
        }
    }
    resetXd(val){
        this.padSetInfo.settingContent.ironing.isSelect=val;
        this.padSetInfo.settingContent.doNotWash.isSelect=val;
        this.padSetInfo.settingContent.noWring.isSelect=val;
        this.padSetInfo.settingContent.lowTemperature.isSelect=val;
        this.padSetInfo.settingContent.dryClean.isSelect=val;
    }
    changeXd(event,type){
      if(!this.isEdit1)return;
      const detail = event;
      switch (type) {
          case 1:
              this.padSetInfo.settingContent.ironing.isSelect=detail;
              break;
          case 2:
              this.padSetInfo.settingContent.doNotWash.isSelect=detail;
              break;
          case 3:
              this.padSetInfo.settingContent.noWring.isSelect=detail;
              break;
          case 4:
              this.padSetInfo.settingContent.lowTemperature.isSelect=detail;
              break;
          case 5:
              this.padSetInfo.settingContent.dryClean.isSelect=detail;
              break;
      
          default:
              break;
      }
      if((!this.padSetInfo.settingContent.ironing.isSelect&&!this.padSetInfo.settingContent.doNotWash.isSelect&&!this.padSetInfo.settingContent.noWring.isSelect&&!this.padSetInfo.settingContent.lowTemperature.isSelect&&!this.padSetInfo.settingContent.dryClean.isSelect)){
            this.padSetInfo.settingContent.washingMethod.isSelect = false;
        }
    }
    finishNum(val,type){
        switch (type) {
            case 1:
                this.padSetInfo2.settingContent.putNum=val;
                break; 
            case 2:
                this.padSetInfo.settingContent.putNum=val;
                break;
            case 3:
                this.padSetInfo3.settingContent.putNum=val;
                break;           
            default:
                break;
        }
    }
    choosePriceUnit(val,type){
        if(!this.isEdit1) return;
        switch (type) {
            case 1:
                this.padSetInfo2.settingContent.currency.value = val;
                break; 
            case 2:
                this.padSetInfo.settingContent.currency.value = val;
                break; 
            case 3:
                this.padSetInfo3.settingContent.currency.value = val;
                break;         
            default:
                break;
        }
        this.showHbPopover = false;
        
    }

    cancelInfo(){
        this.isEdit1 = false;
        this.init();
    }
    //编辑门店信息
    editInfo(){
        this.isEdit1 = true;
    }
    async saveEdit(qhtype=null){
        if(this.isLoading1) return;
        this.isLoading1 = true;
        try {
            if(this.pageSize==1){
                this.padSetInfo2.settingContent.putNum=this.padSetInfo2.settingContent.putNum?this.padSetInfo2.settingContent.putNum:1;
                await TbSettingsPad.PutTbSettings({
                    id:this.padSetInfo2.id,
                    settingContent:JSON.stringify(this.padSetInfo2.settingContent),
                })
            }else if(this.pageSize==2){
                this.padSetInfo.settingContent.putNum=this.padSetInfo.settingContent.putNum?this.padSetInfo.settingContent.putNum:1;
                await TbSettingsPad.PutTbSettings({
                    id:this.padSetInfo.id,
                    settingContent:JSON.stringify(this.padSetInfo.settingContent),
                })
            }else{
                this.padSetInfo3.settingContent.putNum=this.padSetInfo3.settingContent.putNum?this.padSetInfo3.settingContent.putNum:1;
                await TbSettingsPad.PutTbSettings({
                    id:this.padSetInfo3.id,
                    settingContent:JSON.stringify(this.padSetInfo3.settingContent),
                })
            }
            if(qhtype){
                this.pageSize = this.firstSize;
                localStorage.setItem('labelPaperSize',this.pageSize);
            }
            await this.init();
            this.isLoading1 = false;
            this.isEdit1 = false;
            Toast('保存成功');
        } catch (error) {
            this.isLoading1 = false;
        }
    }
    async printTest(){
        if(this.isPrintLoading)return;
        this.isPrintLoading = true;
        let resSetting= null;
        console.log('this.paperSize',this.pageSize);
        if(this.pageSize==1){
            resSetting = await TbSettingsPad.GetTbSettings({settingtype:7})
        }else if(this.pageSize==2){
            resSetting = await TbSettingsPad.GetTbSettings({settingtype:10})
        }else{
            resSetting = await TbSettingsPad.GetTbSettings({settingtype:12})
        }
        let size = this.pageSize==1?"1":this.pageSize==2?'2':"3";
        let form = {}
        if(Number(size)==3){
            form = Object.assign({},{settingContent:resSetting.settingContent},{orderInfoArr:this.labelInfo1},{type:'label'},{paperSize:Number(size)})
        }else{
            form = Object.assign({},{settingContent:resSetting.settingContent},{orderInfoArr:this.labelInfo},{type:'label'},{paperSize:Number(size)})
        }
        console.log('form',form);
        let time = 3000*resSetting.settingContent.putNum
        setTimeout(()=>{
            this.isPrintLoading = false;
        },time)
        if (!isAndroid) {
            window.webkit.messageHandlers.startPrint.postMessage(JSON.stringify(form));
        } else {
            window.printerApi.startPrint(JSON.stringify(form))
        }
    }
    goback(){
        this.$emit('changeTab',{tabActive:2,childActive:1})
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/components/dpInfo.vue